export const MSG_SAVE_SUCCESS = 'Saved successfully.';
export const MSG_ERROR = 'Sorry, an error occurred. Please try again later.';
export const MSG_PAYMENT_REQUIRED =
  'The plan is currently inactive. It may have expired or been revoked by the subscription provider. Please check the plan status before proceeding.';
